import { render } from "./workflowProcess.vue?vue&type=template&id=49764208&scoped=true"
import script from "./workflowProcess.vue?vue&type=script&lang=js"
export * from "./workflowProcess.vue?vue&type=script&lang=js"

import "./workflowProcess.vue?vue&type=style&index=0&id=49764208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49764208"]])

export default __exports__